import React from 'react'
import './Breadcrumbs.css'

const BreadCrumbs = () => {
    return (
        <header>
            <div className="breadcrumbs-container">
                <a href="https://www.onb.ac.at" className="image-link">
                    <img src={require("../../assets/images/home.svg")} alt="Österreichische Nationalbibliothek" />
                </a>
                <span className="arrow"></span>
                <a href="https://www.onb.ac.at/digitale-angebote" className="bold-text breadcrumbs">
                    Digitale Angebote
                </a>
            </div>
        </header>
    );
}

export default BreadCrumbs;
